// features/client/client.validation.js

export const validation = {
  designation_name: (value) => {
    if (!value?.trim()) return "Designation name is required";
    return "";
  },
  designation_code: (value) => {
    if (!value?.trim()) return "Designation code is required";
    if (value.trim().length < 4)
      return "Designation code must be at least 4 characters";
    return "";
  },

};